module.exports = __webpack_public_path__ + "static/fabric-calendar-sidebyside-8259a5e7043323e56ef27dff8cc93f62.png";